export default {
  absences: {
    absenceBalanceCheck: 101573, // Absence Balance Check
    absenceBalances: 101564, // Absence Balances,
    absenceDetails: 101425, // Absence Details
    absenceType: 81220, // Absence Type
    althoughYouCurrentlyHaveASufficientBalanceThisRequestMakes: 101591, // Although you currently have a sufficient balance, this request makes your overall balance insufficient in the future (since it takes into account previously submitted requests
    althoughYouReAbleToSubmitThisRequestYourBalanceIs: 101612, // Although you’re able to submit this request, your balance is currently insufficient.
    approved: 81630, // Approved
    approverNote: 101713, // Approver Note
    approverThatWillBeNotified: 101448, // Approver that will be notified:
    areYouSure: 101617, // Are you sure?
    areYouSureYouWantToCancelThisRequest: 101439, // Are you sure you want to cancel this request? It cannot be undone!
    asOfDate: 101578, // As of {date}
    backToAbsenceRequest: 101586, // Back to Absence Request
    balancesBreakdown: 101583, // Balances Breakdown
    balancesSummary: 101582, // Balances Summary
    breakdown: 101579, // Breakdown
    breakdownOfYourBalance: 101581, // Breakdown of your Balance
    checkBalance: 101574, // Check Balance
    checkingBalance: 101575, // Checking Balance
    chooseExperience: 101613, // Choose Experience
    congratulations: 101458, // Congratulations!
    controlWhichVersionOfThisApplicationYouWouldLikeToByDefault: 101614, // Control which version of this application you would like to login to by default.
    currentBal: 101576, // Current Bal.
    detailsOfYourRecentRequest: 101461, // Details of your recent request
    enterANoteHere: 101447, // Enter a note here (1000 char max.)
    exVacationUnpaidAbsenceEtc: 101445, // Ex. Vacation, Unpaid Absence etc.
    expectedBal: 101577, // Expected Bal.
    futurePlanned: 101567, // Future planned
    holidayOverlap: 103136, // Holiday Overlap
    howMuchPlannedTimeOff: 101570, // How much planned time off do you have until the end of the absence period
    howMuchTimeHaveYouTakenUpToToday: 101569, // How much time have you taken up to today
    insufficientSchedulingInformation: 100912, // Warning: The absence range contains days where there is no scheduled time. Future schedule changes may impact the forecasted balance shown
    leaveANote: 101446, // Leave a note
    myAbsences: 95387, // My Absences
    noAbsencesYet: 101430, // No absences yet!
    note: 46263, // Note
    nothingToShow: 101423, // Nothing to show!
    oopsAnErrorOccurredWhileGettingYourAbsenceStatuses: 101511, // Oops! An error occurred while getting your absence statuses
    oopsAnErrorOccurredWhileGettingYourAbsenceTypes: 101513, // Oops! An error occurred while getting your absence types
    oopsAnErrorOccurredWhileGettingYourApprovers: 101510, // Oops! An error occurred while getting your approvers
    oopsAnErrorOccurredWhileGettingYourListOfAbsences: 101509, // Oops! An error occurred while getting your list of absences
    oopsAnErrorOccurredWhileGettingYourListOfScheduledAbsences: 101512, // Oops! An error occurred while getting your list of scheduled absences
    oopsAnErrorOccurredWhileValidatingYourInputs: 101514, // Oops! An error occurred while validating your inputs. Please try again later.
    outsideOfSchedule: 101526, // Outside of Schedule:
    partialDay: 100872, // Partial Day
    partialDayQuestion: 101443, // Partial Day?
    pending: 91920, // Pending
    pleaseKeepInMind: 101451, // Please keep in mind!
    pleaseNote: 101621, // Please Note:
    rejected: 91922, // Rejected
    request: 101585, // Request
    requestAnAbsence: 101426, // Request an absence
    scheduledAbsence: 45647, // Scheduled Absence
    schedules: 45601, // Schedules
    selectAbsenceType: 91670, // Select Absence Type
    selectDate: 101444, // Select Date
    selectDay: 101450, // Select Day
    showingCountRows: 101584, // Showing {count} rows
    shownBelowAreYourUpcomingAbsences: 101427, // Shown below are your upcoming absences
    sorryYouNeedApproversToRequestAnAbsence: 101456, // Sorry! You need approvers to request an absence.
    status: 46200, // Status
    submitAbsenceRequest: 95854, // Submit Absence Request
    submitAnotherRequest: 101460, // Submit Another Request
    success: 101457, // Success!
    summaryOfYourTimeOffBalances: 101571, // Summary of your time off balances
    switchToAgileClassic: 101620, // Switch to Agile Classic
    theNextTimeYouLoginYouWillBePresentedWithTheAgileClassicView: 101618, //The next time you login, you will be presented with the Agile Classic View!
    thisFeatureAllowsYouToRequestAFewHoursOff: 101449, // This feature allows you to request a few hours off on any given day
    todaysBalance: 101566, // Today's Balance
    totalBalanceLeftAsOfToday: 101568, // Total balance left as of today
    type: 45476, // Type
    upcomingAbsences: 101082, // Upcoming Absences
    usedToDate: 101565, // Used to date
    validationWasSuccessful: 101607, // Validation was successful!
    viewAllAbsenceDetails: 101462, // View All Absence Details
    viewBreakdown: 101580, // View Breakdown
    viewBreakdownBelowForMoreInfo: 101590, // View breakdown below for more info!
    youDoNotHaveAnyPastOrUpcomingAbsences: 101431, // You do not have any past or upcoming absences in the system.
    youDonTHaveAnEnoughLeftOnYourBalanceTo: 101589, // You don’t have an enough left on your balance to submit this request.
    youHaveASufficientBalanceToSubmitThisAbsenceRequest: 101587, // You have a sufficient balance to submit this absence request. Make sure to take good rest!
    youHaveNoUpcomingPlannedAbsences: 101424, // You have no upcoming planned absences
    youLlBeRedirectedToTheAgileClassicExperience: 101622, // You’ll be redirected to the Agile Classic Experience, when you click on ‘Yes’.
    youWillBeAbleToSubmitAbsenceRequestsHere: 101442, // You will be able to submit absence requests here!
    youWillBeAbleToViewDetailsRegardingAllYourAbsencesHere: 101441, // You will be able to view details regarding all your absences here
    yourAbsenceRequestDoesNotFallWithinYourSchedule: 101527, // Your absence request does not fall within your schedule for the date requested. Only hours within your scheduled time would count towards the absence. Do you wish to continue?
    yourAbsenceRequestHasBeenSubmitted: 101459, // Your absence request has been submitted. Sit tight - you'll be notified of your request status soon :)
    yourSelectedDatesOverlapWithNameDoYouWant: 103135, // Your selected dates overlap with {name}. Do you want to proceed?
  }
}
